export default class PositionModel {
  constructor (data) {
    this.logentries = []
    this.person = null
    this.location = null

    this.values = {
      id: null,
      person_id: null,
      location_id: null,
      department: null,
      title: null,
      phone: null,
      mobile: null,
      fax: null,
      email: null,
      sendchristmasemail: null,
      sendchristmascard: null,
      start: null,
      end: null
    }

    window.PRIM.modelMapper.mapToModel(data, this.values)
  }

  getTitle () {
    return [this.values.title].join(' ')
  }
  
  getSubtitle () {
    let title = []

    if (this.values.department) {
      title.push(this.values.department)
    }

    if (this.location) {
      if (this.location.values.business) {
        title.push(this.location.values.business)
      }

      if (this.location.values.visitcity) {
        title.push(this.location.values.visitcity)
      }

      if (this.location.organisation && this.location.organisation.values.name) {
        title.push(this.location.organisation.values.name)
      }
    }

    return title.join(' ')
  }

  getImage () {
    let image = null

    if (this.person && this.person.getImage) {
      image = this.person.getImage()
    }

    if (!image && this.location && this.location.getImage) {
      image = this.location.getImage()
    }

    return image
  }

  getIndex () {
    if (this.getCompareString()) {
      return this.getCompareString().substring(0, 1).toUpperCase()
    }

    return null
  }

  getCompareString () {
    let title = []

    if (this.values.title) {
      title.push(this.values.title)
    }

    if (this.values.department) {
      title.push(this.values.department)
    }

    if (this.location) {
      if (this.location.values.business) {
        title.push(this.location.values.business)
      }

      if (this.location.values.visitcity) {
        title.push(this.location.values.visitcity)
      }

      if (this.location.organisation && this.location.organisation.values.name) {
        title.push(this.location.organisation.values.name)
      }
    }

    return title.join(' ')
  }

  getJSON () {
    let result = {}

    window.PRIM.modelMapper.mapToObject(this.values, result)

    return result
  }
}



// WEBPACK FOOTER //
// ./js/modules/position/model/PositionModel.js